import * as config from './config.js';

$('body').on('click', '.btn-register', function(e) {
    e.preventDefault();
    var btn = $(this);
    $.ajax({
        url: '/register-line',
        type: 'POST',
        dataType: 'json',
        data: {
            line_page_id: btn.attr('data-line-page-id'),
            broker_id: btn.attr('data-broker-id')
        },
        beforeSend: function() {
            config.showLoading($('#line'));
            btn.addClass('disabled');
        },
        success: function(res) {
            config.hideLoading();
            if (res.status == 'error') {
                btn.prev('.error-message').html(res.message).removeClass('d-none');
            } else {
                location.href = res.url;
            }
        },
        error: function() {
            console.log('エラー');
        }
    });
});
// 
// on click floating banner
$('body').on('click', '.floating-banner', function(e) {
    $('html, body').animate({ scrollTop: $(".form-group").offset().top }, '2000');

});
$(function() {
    config.breakStr();
    config.breakStrButton();
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        if ($('.floating-banner').length>0) {
            $('body').css({
                'padding-bottom' : ($('.floating-banner').height() + 30) + 'px'
            });
        }
    }
});